import { createBrowserRouter } from "react-router";
import RootLayout from "./layout/RootLayout";
import LandingPage from "./pages/LandingPage";
import FeedbackPage from "./pages/FeedbackPage";
import TeacherLogin from "./pages/TeacherLogin";
import TeacherDashboard from "./pages/TeacherDashboard";
import LessonBuilder from "./pages/LessonBuilder";
import LiveSessionTeacher from "./pages/LiveSessionTeacher";
import StudentPacedMonitoring from "./pages/StudentPacedMonitoring";
import StudentJoin from "./pages/StudentJoin";
import StudentLiveView from "./pages/StudentLiveView";
import DemoActivities from "./pages/DemoActivities";
import DevGuide from "./pages/DevGuide";
import Reports from "./pages/Reports";
import Students from "./pages/Students";
import Gradebook from "./pages/Gradebook";
import Settings from "./pages/Settings";
import GradebookLessonView from "./pages/GradebookLessonView";
import StudentPerformanceDetail from "./pages/StudentPerformanceDetail";
import GradeSettings from "./pages/GradeSettings";
import ActivityGrading from "./pages/ActivityGrading";
import StudentDashboard from "./pages/StudentDashboard";
import StudentGrades from "./pages/StudentGrades";
import StudentLessonDetail from "./pages/StudentLessonDetail";
import StudentActivityFeedback from "./pages/StudentActivityFeedback";
import StudentNotifications from "./pages/StudentNotifications";
import NotFound from "./pages/NotFound";
import DemoMatchingPairs from "./pages/DemoMatchingPairs";
import DemoTimeToClimb from "./pages/DemoTimeToClimb";
import DemoDrawIt from "./pages/DemoDrawIt";
import DemoCollaborateBoard from "./pages/DemoCollaborateBoard";
import DemoWordCloud from "./pages/DemoWordCloud";
import DemoLabelDiagram from "./pages/DemoLabelDiagram";
import DemoQuiz from "./pages/DemoQuiz";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: RootLayout,
    children: [
      {
        index: true,
        Component: LandingPage,
      },
      {
        path: "feedback",
        Component: FeedbackPage,
      },
      {
        path: "teacher/login",
        Component: TeacherLogin,
      },
      {
        path: "teacher/dashboard",
        Component: TeacherDashboard,
      },
      {
        path: "teacher/lesson/:lessonId",
        Component: LessonBuilder,
      },
      {
        path: "teacher/live/:sessionId",
        Component: LiveSessionTeacher,
      },
      {
        path: "teacher/student-paced/:sessionId",
        Component: StudentPacedMonitoring,
      },
      {
        path: "teacher/reports",
        Component: Reports,
      },
      {
        path: "teacher/students",
        Component: Students,
      },
      {
        path: "teacher/settings",
        Component: Settings,
      },
      {
        path: "gradebook",
        Component: Gradebook,
      },
      {
        path: "gradebook/lesson-view",
        Component: GradebookLessonView,
      },
      {
        path: "gradebook/student/:studentId",
        Component: StudentPerformanceDetail,
      },
      {
        path: "gradebook/settings",
        Component: GradeSettings,
      },
      {
        path: "gradebook/grade/:studentId/:activityId",
        Component: ActivityGrading,
      },
      {
        path: "join",
        Component: StudentJoin,
      },
      {
        path: "student/live/:sessionId",
        Component: StudentLiveView,
      },
      {
        path: "demos",
        Component: DemoActivities,
      },
      {
        path: "dev-guide",
        Component: DevGuide,
      },
      // Activity Demos
      {
        path: "demo/matching-pairs",
        Component: DemoMatchingPairs,
      },
      {
        path: "demo/time-to-climb",
        Component: DemoTimeToClimb,
      },
      {
        path: "demo/draw-it",
        Component: DemoDrawIt,
      },
      {
        path: "demo/collaborate-board",
        Component: DemoCollaborateBoard,
      },
      {
        path: "demo/word-cloud",
        Component: DemoWordCloud,
      },
      {
        path: "demo/label-diagram",
        Component: DemoLabelDiagram,
      },
      {
        path: "demo/quiz",
        Component: DemoQuiz,
      },
      // Student Routes
      {
        path: "student/dashboard",
        Component: StudentDashboard,
      },
      {
        path: "student/grades",
        Component: StudentGrades,
      },
      {
        path: "student/lesson/:lessonId",
        Component: StudentLessonDetail,
      },
      {
        path: "student/activity/:activityId",
        Component: StudentActivityFeedback,
      },
      {
        path: "student/notifications",
        Component: StudentNotifications,
      },
      {
        path: "*",
        Component: NotFound,
      },
    ],
  },
]);